import React from 'react';

const StoneLogo: React.FC = () => {
  return (
    <div
      style={{
        width: '100%',
        padding: '10px 20px 0 20px',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <a href="https://stone.com.br" target={'_blank'} rel="noopener noreferrer">
        <img
          src={`https://storage.googleapis.com/partnerhub_partner_badges_prod/D_62a3a8871afcde00197b95d0.png`}
          alt="image_not_found"
          style={{ height: 80 }}
        />
      </a>
    </div>
  );
};
export default StoneLogo;
